module.exports = __webpack_public_path__ + "images/70273a6bdf7d5933ead58805afcb30b3.svg";